import moment from "moment-ferie-fr";
import "moment-timezone";
import { getUnixTimeFromDate } from "helpers/getUnixTimeFromDate";
import { formatDate } from "helpers/formatDate";
import { SHIPPING_OPTIONS } from "../../../constants";
const DATE_FORMAT = "DD/MM/YYYY";

// function to add only "X jours ouvrables"
export function addWeekdays(days) {
  let date = moment();
  let weekDaysToAdd = 0;

  while (days >= 0) {
    weekDaysToAdd += 1;
    // decrease "days" only if it's a weekday.
    if (date.day() !== 6 && date.day() !== 0 && !date.isFerie()) {
      days -= 1;
    }
    date = date.add(1, "days");
  }
  // weekDaysToAdd is weekday to add including current day, so we decrement by one for
  // having days to add at current day
  return weekDaysToAdd - 1;
}

// Compute day delays taking distance and hour in count
export function computeDelay(shipping, homeShipping) {
  const isParis = ["75", "77", "78", "91", "92", "93", "94", "95"].some(
    (el) => shipping?.address?.zipcode && shipping?.address?.zipcode.toString().startsWith(el)
  );
  if (moment().tz("Europe/Paris").hour() < 15) {
    if (homeShipping) {
      if (isParis) {
        return 1;
      } else {
        return 3;
      }
    } else {
      if (isParis) {
        return 1;
      } else {
        return 4;
      }
    }
  } else {
    if (homeShipping) {
      if (isParis) {
        return 2;
      } else {
        return 4;
      }
    } else {
      if (isParis) {
        return 2;
      } else {
        return 5;
      }
    }
  }
}

export function checkDateValidity(cart) {
  const homeShipping = SHIPPING_OPTIONS.findIndex((el) => el.type === cart.shipping?.delivery_option_type) === 0;
  const dayDelay = addWeekdays(computeDelay(cart.shipping, homeShipping));
  if (cart.shipping.date) {
    return moment(cart.shipping.date, DATE_FORMAT).diff(moment().add(dayDelay), "days") >= 0;
  }
  return false;
}

export const getMaxTimeslots = (data) => {
  return Object.values(data).reduce((length, timeslot) => {
    if (length < timeslot.length) {
      length = timeslot.length;
    }
    return length;
  }, 0);
};

export const calendarSkeleton = (len, date) =>
  Array.from({ length: len }, (_, index) => {
    return {
      day: getUnixTimeFromDate(moment(date).add(index, "d")),
      displayDate: formatDate(moment(date).add(index, "d")),
    };
  });

export const formatData = (formattedTimeslots, timeslot) => {
  const day = getUnixTimeFromDate(moment(timeslot.time_span_beginning).format("YYYY-MM-DD")); // needed to force the right day to avoid an offset of 1
  if (day in formattedTimeslots) {
    formattedTimeslots[day].push({
      ...timeslot,
    });
  } else {
    formattedTimeslots = {
      ...formattedTimeslots,
      [day]: [
        {
          ...timeslot,
        },
      ],
    };
  }

  return formattedTimeslots;
};
